/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react';

import ToggleButton from '@/components/togglebutton/src/ToggleButtonCustom';
import {CYCLE_LOG_PROFILE_MODE} from '@/constants/enums';
import {COLUMN_9} from '@/constants/pcConstAppStyle';
import {useCycleHistoryProfileModeContext} from '@/contexts/CycleHistoryContext';

function CycleHistoryPageProfileSelection() {
  const {profileMode, SetProfileMode} = useCycleHistoryProfileModeContext();
  // const toggleCheckboxValue = () => {
  //   SetSelectAll(!selectAll);
  //   console.log('selectAll: ', selectAll);
  // };

  const profileSetupButtonProp = [
    {
      label: CYCLE_LOG_PROFILE_MODE.ALL.toUpperCase(),
      id: CYCLE_LOG_PROFILE_MODE.ALL,
      value: CYCLE_LOG_PROFILE_MODE.ALL,
    },
    {
      label: CYCLE_LOG_PROFILE_MODE.AUTO_PROFILE.toUpperCase(),
      id: CYCLE_LOG_PROFILE_MODE.AUTO_PROFILE,
      value: CYCLE_LOG_PROFILE_MODE.AUTO_PROFILE,
    },
    {
      label: CYCLE_LOG_PROFILE_MODE.MANUAL_PROFILE.toUpperCase(),
      id: CYCLE_LOG_PROFILE_MODE.MANUAL_PROFILE,
      value: CYCLE_LOG_PROFILE_MODE.MANUAL_PROFILE,
    },
  ];

  /**
   * @param {Event} evt
   */
  const OnProfileModeSelectionChangeHandler = (evt) => {
    const {id} = evt.currentTarget;
    SetProfileMode(id);
  };

  const CycleHistoryPageProfileSelectionStyle = css({
    height: '70px',
    padding: '2px',
    display: 'flex',
    alignItems: 'center',
  });

  const CycleHistoryPageProfileToggleStyle = css({
    paddingRight: '0px',
    paddingLeft: '20px',
    margin: '0px',
  });
  // const CheckBoxInput = css({
  //   height: '28px',
  //   width: '28px',
  //   left: '2px',
  //   top: '2px',
  // });
  // const SelectAllText = css({
  //   height: '32px',
  //   width: '140px',
  //   left: '66px',
  //   top: '14px',
  //   'border-radius': 'nullpx',
  //   'font-family': 'Roboto',
  //   'font-size': '22px',
  //   'font-weight': '400',
  //   'line-height': '26px',
  //   'letter-spacing': '0em',
  //   'text-align': 'left',
  // });

  const mainx = css({
    /* Profile History */

    /* Auto layout */

    display: 'flex',
    'flex-direction': 'row',
    'align-items': 'center',
    padding: '0px, 16px',
    // gap: '18px',

    // 'position': 'absolute',
    width: '960px',
    height: '60px',
    left: '0px',
    top: '0px',

    'border-radius': '8px',
  });

  return (
    <div css={CycleHistoryPageProfileSelectionStyle}>
      <div
        css={CycleHistoryPageProfileToggleStyle}
        className={COLUMN_9}
      >
        {/* <CheckBox
              id="select_all_checkbox"
              onChange={toggleCheckboxValue}
              value={selectAll}
              text={'Select All'} //v
            /> */}
        <div css={mainx}>
          {/* <input
            css={CheckBoxInput}
            type="checkbox"
            id="id"
            name="name"
            value="value"
            checked={selectAll}
            onChange={toggleCheckboxValue}/>
          <span css={SelectAllText}>Select All</span> */}
          <ToggleButton
            buttonProp={profileSetupButtonProp}
            defaultValue={profileMode}
            value={profileMode}
            onClick={OnProfileModeSelectionChangeHandler}
          />
        </div>
      </div>
    </div>
  );
}
export default CycleHistoryPageProfileSelection;
